import { useContext } from "react";
import RequestQuoteFormContext from "./RequestQuoteFormContext";

const Done = () => {
	const { next } = useContext(RequestQuoteFormContext);
	return (
		<div>
			<p className="mb-0 text-center mt-5">
				Thank you! <br />
				Your submission has been received. We’ll get back to you shortly.
			</p>
			<div className="d-flex justify-content-center mt-2 mb-5">
				<button
					onClick={() => {
						next();
					}}
					className="btn btn-primary w-auto px-5"
				>
					Close
				</button>
			</div>
		</div>
	);
};
export default Done;
